import { Text } from "@mantine/core";
import { useMemo } from "react";
import { useSelector } from "src/redux/hooks";
interface Props {
  sectionIndex: number;
}
const TimeWarning = ({ sectionIndex }: Props) => {
  const {
    features,
    lbentry: { sections },
  } = useSelector(state => state.generatorSlice);
  const displayTextWarning = useMemo(() => {
    if (
      !features?.timeValidation ||
      Object.keys(features?.timeValidation).length === 0
    )
      return false;

    return sections[sectionIndex].rows.some(el => {
      const comparator = (cols: any) => {
        const inputKeys = Object.keys(cols).filter(
          key => cols[key].unit === "24lock",
        );
        let isPresent = false;
        Object.keys(features.timeValidation).forEach(key => {
          if (inputKeys.includes(key)) {
            isPresent = true;
          }
        });
        return isPresent;
      };

      if (el.cols) {
        return comparator(el.cols);
      } else if (el.subrows) {
        return el.subrows.some((subrow: any) => comparator(subrow.cols));
      }
      return false;
    });
  }, [sections, sectionIndex, features]);

  if (displayTextWarning) {
    return (
      <Text fw={200} c="red" ta="center" size="sm">
        Arrange this entry in the correct chronological order for the specified
        date. If it belongs to a new day, delete this row and click on "New
        Entry" to begin a new day's record.
      </Text>
    );
  }
  return null;
};
export default TimeWarning;
